export const assetMediaType = item => item.type === 'volc-asset'
  ? ({ Image: 'image', Video: 'video', Audio: 'audio' }[item.assetType] || 'image')
  : item.type

export const assetSelectionKey = item => String(item.assetId ? `volc-${item.assetId}` : item.id || `${item.type}:${item.uuid}`)

export const assetDisplayName = item => item.name || item.uuid || item.fileName || '未命名素材'

// Display library assets in server order without changing reference numbering.
export function orderedLibraryItems(assets, queued = []) {
  const overrides = new Map(queued.map(item => [assetSelectionKey(item), item]))
  const keys = new Set(assets.map(assetSelectionKey))
  return [...queued.filter(item => !keys.has(assetSelectionKey(item))),
    ...assets.map(item => ({ ...item, ...overrides.get(assetSelectionKey(item)) }))]
}

export function assetSelectionReason(item, { selected = [], limits = {}, isWan = false } = {}) {
  const type = assetMediaType(item)
  const category = { image: 'images', video: 'videos', audio: 'audios' }[type]
  if (!category) return '该素材不支持加入参考'
  const sourceUrl = item.queueEntry?.url || item.sourceUrl
  if (isWan && !/^https?:\/\//i.test(String(sourceUrl || '').trim())) return '该素材缺少可下载的公开地址（source_url），无法用于当前模型'
  const url = item.queueEntry?.url || (!isWan && item.isRealPerson && type === 'image' ? item.assetUri : item.sourceUrl || item.mediaUrl || item.url)
  if (!url) return '素材暂无可用链接'
  const pending = selected.filter(asset => assetMediaType(asset) === type && assetSelectionKey(asset) !== assetSelectionKey(item)).length
  if (pending >= limits[category]) {
    return `最多添加 ${limits[category]} ${type === 'image' ? '张图片' : type === 'video' ? '个视频' : '个音频'}`
  }
  return ''
}

// Retain uploads and their metadata; create new library entries only on confirmation.
export function assetLibraryReference(item, isWan = false) {
  if (item.queueEntry) return item.queueEntry
  const type = assetMediaType(item)
  const privateImage = !isWan && type === 'image' && item.isRealPerson
  const url = privateImage ? item.assetUri : item.sourceUrl || item.mediaUrl || item.url
  return {
    url, localUrl: type === 'image' ? item.coverUrl || url : '', uploading: false,
    fileName: assetDisplayName(item), duration: Number(item.duration) || 0,
    ...(type === 'image' ? { role: isWan ? 'reference_image' : 'reference' } : {}),
    ...(item.assetId ? { volcAssetId: item.assetId, volcAssetName: item.name || '' } : {}),
    ...(privateImage ? { isVolcAsset: true, volcAssetCover: item.coverUrl || '' } : {})
  }
}

export function remapLibraryMentions(text, previous, selected) {
  const names = new Map()
  for (const [type, prefix] of [['image', '图片'], ['video', '视频'], ['audio', '音频']]) {
    const next = selected.filter(item => assetMediaType(item) === type).map(assetSelectionKey)
    previous.filter(item => assetMediaType(item) === type).forEach((item, index) => {
      const nextIndex = next.indexOf(assetSelectionKey(item))
      names.set(`${prefix}${index + 1}`, nextIndex < 0 ? '' : `@${prefix}${nextIndex + 1}`)
    })
  }
  return text.replace(/@(图片|视频|音频)\d+/g, token => names.get(token.slice(1)) ?? token)
}
